<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="steps-toolbar">
    <div
            (click)="stepChanged(step.id, step.step)"
            (keydown)="stepChanged(step.id, step.step)"
            (mouseenter)="collapseStep(step, false)"
            (mouseleave)="collapseStep(step, true)"
            *ngFor="let step of stepsList; trackBy: trackId"
            [ngClass]="{
            'step--open': (!step.collapse || step.keepOpen) && !infoWindowsService.isWindowOpen,
            'step--enable': step.step === selectedStepNumber && !infoWindowsService.isWindowOpen,
            'step--disable': checkSteepDisabled(step.id)
        }"
            class="steps-toolbar__item step {{ step.stepAdditionalStyle }} step--{{ step.id }} "
    >
        <h5 class="step__title">
            {{ step.id }}. <span class="d-none d-lg-inline">{{ step.title }}</span>
        </h5>

        <div [ngSwitch]="step.id" class="step__content">
            <winde-step-enter-location (stateChanged)="modeChanged($event)" *ngSwitchCase="1"></winde-step-enter-location>

            <winde-step-los (stateChanged)="modeChanged($event)" *ngSwitchCase="2"></winde-step-los>

            <winde-step-plan *ngSwitchCase="3"></winde-step-plan>

            <winde-step-reports *ngSwitchCase="4"></winde-step-reports>

            <winde-step-bom *ngSwitchCase="5"></winde-step-bom>
        </div>
    </div>
</div>
